import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AlertContainer from '@components/Alerts/presentationComponents/AlertContainer';
import AlertHeader from '@components/Alerts/presentationComponents/AlertHeader';
import AlertHeaderNote from '@components/Alerts/presentationComponents/AlertHeaderNote';
import { AlertProps } from './AlertProps';
import { AlertBody } from '@components/Alerts/AlertBody/AlertBody';
import { utcToLocalTime } from '@utilities/dateUtilities';
import { UserProfileHasARoleSelector } from '@store/selectors/UserProfileSelector';
import AlertDetails from '@components/Alerts/presentationComponents/AlertDetails';
import Chip from '@components/Chip/Chip';

const useStyles = makeStyles((theme) => createStyles({
	footerBox: {
		alignItems: 'end',
		borderTop: `1px solid ${theme.palette.grey[400]}`,
		display: 'flex',
		flexDirection: 'column',
		paddingTop: theme.spacing(1.5),
		width: '100%',
	},
}));

export const Alert = ({
	chipColor,
	headerColor,
	chipText,
	headerText,
	body,
	footer,
	alertUser,
	alertTime,
	showForRoles,
	...rest
}: AlertProps) => {
	const classes= useStyles();
	const convertedDate = utcToLocalTime(alertTime);

	if (!useSelector(UserProfileHasARoleSelector(showForRoles)) && showForRoles) { return null; }

	return (
		<AlertContainer {...rest}>
			<AlertHeader style={{ backgroundColor: headerColor }}>
				{chipColor && chipText && (
					<Chip
						color={chipColor}
						label={chipText}
						data-field={`caseDetails-alertTag-${chipText}`}
					/>
				)}
				<AlertHeaderNote>{headerText}</AlertHeaderNote>
			</AlertHeader>
			{alertUser || alertTime ? (
				<AlertBody alertUser={alertUser} alertTime={convertedDate} body={body} />
			) : (
				body
			)}
			{footer && (
				<AlertDetails data-testid="alertFooter">
					<Box className={classes.footerBox}>{footer}</Box>
				</AlertDetails>
			)}
		</AlertContainer>
	);
};
